var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var PartialCheck = function PartialCheck(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 8 6' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('defs', null),
      React.createElement('path', { d: 'M0 2h8v2H0z', className: 'cls-1' })
    )
  );
};
/*eslint-enable */

export default PartialCheck;
//# sourceMappingURL=PartialCheck.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/PartialCheck.js